import axios from 'axios'

const getCountry = async (cb): Promise<Record<string, string>> => {
  try {
    const {data} = await axios.get('/browsing_context_suggestions.json');
    if (!data.detected_values || !data.detected_values.country) {
      return {}
    }
    const country = data.detected_values.country
    if (!window['blubolt']) {
      window['blubolt'] = {};
    }
    window['blubolt'].geo = country
    if (typeof cb === 'function') {
      cb(country)
    }
    return country
  } catch (e) {
    console.error(e);
    return {}
  }

}

export default getCountry